import { render } from "./form-eer-investment-money.html?vue&type=template&id=612e4efc&scoped=true&ts=true&external"
import script from "./form-eer-investment-money.ts?vue&type=script&lang=ts&external"
export * from "./form-eer-investment-money.ts?vue&type=script&lang=ts&external"

import "./form-eer-investment-money.scss?vue&type=style&index=0&id=612e4efc&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612e4efc"]])

export default __exports__